const wrapBundle = document.querySelector(".embla.bundle");

const setupDotBtnsBundle = (dotsArray, embla) => {
  dotsArray.forEach((dotNode, i) => {
    dotNode.addEventListener("click", () => embla.scrollTo(i), false);
  });
};

const generateDotBtnsBundle = (dots, embla) => {
  const template = document.getElementById("embla-dot-template-bundle").innerHTML;
  dots.innerHTML = embla.scrollSnapList().reduce((acc) => acc + template, "");
  return [].slice.call(dots.querySelectorAll(".embla__dot.bundle__dot"));
};

const selectDotBtnBundle = (dotsArray, embla) => () => {
  const previous = embla.previousScrollSnap();
  const selected = embla.selectedScrollSnap();
  dotsArray[previous].classList.remove("is-selected");
  dotsArray[selected].classList.add("is-selected");
};

const viewPortBundle = wrapBundle.querySelector(".embla__viewport.bundle__viewport");
const dotsBundle = document.querySelector(".embla__dots.bundle__dots");
const emblaBundle = EmblaCarousel(viewPortBundle, { loop: false, skipSnaps: false, align: "start", containScroll: "trimSnaps", breakpoints: {'(min-width: 991px)': { active: false, align: "center" }}});
const dotsArrayBundle = generateDotBtnsBundle(dotsBundle, emblaBundle);
const setSelectedDotBtnBundle = selectDotBtnBundle(dotsArrayBundle, emblaBundle);

setupDotBtnsBundle(dotsArrayBundle, emblaBundle);

emblaBundle.on("select", setSelectedDotBtnBundle);
emblaBundle.on("init", setSelectedDotBtnBundle);
